var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,[React.createElement("line",{"strokeMiterlimit":"10","x1":"0","y1":"2","x2":"24","y2":"2","key":0}),React.createElement("line",{"strokeMiterlimit":"10","x1":"0","y1":"9","x2":"24","y2":"9","key":1}),React.createElement("line",{"strokeMiterlimit":"10","x1":"0","y1":"16","x2":"24","y2":"16","key":2})]);
}

Hamburger.defaultProps = {"id":"hamburger-icon--even","viewBox":"0 0 24 18"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
